import { observable, action, makeObservable, runInAction } from "mobx";
import { Cookies } from "react-cookie";
import { toast } from "react-toastify";
import { MyConstants } from "../Constants/MyConstants";
import jwt_decode from "jwt-decode";
import { noImageUrl } from "../API/URL";
import {
  fetchY2yAssetScopeEmissions,
  fetchY2yAssetEnergy,
  fetchY2yAssetWater,
  getCustomEmissionFactorList,
  getCustomEmissionFactorCount,
  getAllChildCompanyCount,
  getExpiryUserCount,
  getAllChildCompanyList,
  DeleteCustomEmissionFactorList,
  changeVerifyStatus,
  fetchAssetList,
  getAllUserOperator,
  getAllFacilityCompanyList,
} from "../API/api.group";
import { addFeedback, getFeedbackList } from "../API/api.feedback";
import "../config";
import i18n from "../i18n";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
} from "../services/toast";

const showUnknownError = (error) => {
  console.error("Request failed", error);
  return handleAPIError(error, {
    throwError: false,
  });
};
class Common {
  cookies = new Cookies();
  companyList = this.cookies.get("companyList");
  focusArea = this.cookies.get("focusArea");
  userId = this.cookies.get("userId");
  userEmail = this.cookies.get("email");
  permittedBuilding = null;
  allBuildingType = null;
  accessmentList = null;
  token = this.cookies.get("Token");
  role = this.token && jwt_decode(this.token).role;
  userLevel = this.cookies.get("userLevel");
  siteModuleData = this.cookies.get("siteModuleData");
  usedRegion = this.cookies.get("usedRegion");
  isBlueOnion = this.cookies.get("isBlueOnion");
  blueOnionUserDisplayName = this.cookies.get("blueOnionUserDisplayName");
  companyId = this.siteModuleData?._id;
  company_list = null;
  company_list_v2 = null;
  companyName = this.siteModuleData?.companyName;
  trackingChart = this.siteModuleData?.trackingChart || "Monthly";
  groupStatus = this.siteModuleData?.modules?.Group_Report;
  buildingName = null;
  deleteCheckedArray = [];
  selectedCertifications = [];
  commit;
  isClickedDeleteSite = false;
  certification = null;
  certificateArray = [];
  tokenStatus = "INACTIVE";
  uploadLogoImage = "";
  photo = null;
  frameworkDescription = "";
  frameworkTitle = "";
  activityLog = null;
  y2yEnergy = null;
  y2yS1Emissions = null;
  y2yS2Emissions = null;
  y2yS3Emissions = null;
  y2yWater = null;
  frameworkProgress = [];
  userName = this.cookies.get("userName");
  theme = "light";
  isDarkMode = localStorage.getItem("theme") === "dark";
  isHover = false;
  hoverId = null;
  permittedBuildingLoading = false;
  demoSitePerformanceData = {};
  list = [];
  selectedYear = "All";
  selectedPeriod = "yearly";
  selectedMonth = "All";
  selectedQuarter = "All";
  selectedQuarterLabel = "All";
  showBaseLineModal = false;
  viewStatus = "normalView";
  tableColumns = [];
  yearOptions = [];
  netZeroYearOptions = [];
  minBaselineYear = 2018;
  assetList = [];
  language = localStorage.getItem("i18nextLng") || "en";

  y2yAssetEnergy = [];
  y2yAssetS1Emissions = [];
  y2yAssetS2Emissions = [];
  y2yAssetS3Emissions = [];

  baseLineAssetS1Consumption = [];
  baseLineAssetS2Consumption = [];
  baseLineAssetS3Consumption = [];

  baseLineAssetS1Emissions = [];
  baseLineAssetS2Emissions = [];
  baseLineAssetS3Emissions = [];

  feedback = {
    feedbackType: null,
    feedbackData: {
      message: null,
    },
    suggesstion: null,
  };
  feedbackSubmitted = false;
  feedbackList = [];
  customEmissionFactorList = [];
  customEmissionFactorCount = null;
  getAllChildCompanyCount = null;
  getExpiryUserCount = null;
  allChildCompanyList = [];
  allFacilityCompanyList = [];
  allUserOperators = [];
  detailedCustomFactor = [];
  showDeleteDialog = false;
  deletCustomEmissionData = {};
  errorAlertMessage = "";
  selectedCompany =
    this.role === MyConstants.SUPER_ADMIN || this.role === MyConstants.VIEWER
      ? this.siteModuleData?._id
      : this.userId; // initial 1 or this.siteModuleData?._id

  customEmission = ["Verified", "Not Verified", "Rejected"];
  childCompanyNavbar = [
    "Request List To Delete",
    "All Subsidiaries",
    "Deleted Subsidiaries",
  ];
  facilityCompanyNavbar = [
    "Request List To Delete",
    "All Facilities",
    "Deleted Facilities",
  ];
  selectedCustomEmission = "Verified";
  selectedChildCompany = "All Subsidiaries";
  selectedFacilityCompany = "All Facilities";
  field = "All Fields";
  emissionUnit = "kgCO₂-e";
  PCFUserIdData = [
    "64ae6763f18eaaf7c2b46c61",
    "64ae66d7f18eaaf7c2b46c47",
    "6684f2fde1303f116daa7b86",
    "6684f64ce1303f116daa7d88",
    "66a481d89bceca2a09bed6e6",
    "66a482119bceca2a09bed811",
    "66b9876acb6dd7f6af469d6d",
    "66d5509a3d92bff9615916b6",
    "66d54fe83d92bff961590f67",
    "66d5512a3d92bff961592a4d",
    "66dea75115d9e54f064650e0",
    "66dea7d7fc1752dce132a7d3",
    "66e51c6c90e3c5fac8d3115c",
    "66e51b5ddaffa8345a11266a",
    "66e51beb0ef1a22970e5227e",
  ];
  CTBCUserIdData = [
    "66bdabb863967acab8685544",
    "66bdab6e63967acab868535c",
    "66bdaa2463967acab8685174",
    "66d2b51e88b23bd661b4bb20",
  ];
  excelSelectDownload = {
    yes: false,
    no: false,
    all: true,
  };
  excelYearOptions = [];
  selectedScope = 1;
  selectedExcelYear = new Date().getFullYear();
  selectedCategory = "Stationary Combustion";
  selectedLabel = "1.1 Stationary Combustion";
  isPCF = this.cookies.get("isPCF");
  isCTBC = this.cookies.get("isCTBC");

  constructor() {
    makeObservable(this, {
      usedRegion: observable,
      token: observable,
      userName: observable,
      selectedYear: observable,
      selectedPeriod: observable,
      selectedMonth: observable,
      selectedQuarter: observable,
      selectedQuarterLabel: observable,
      role: observable,
      userLevel: observable,
      companyList: observable,
      userId: observable,
      buildingName: observable,
      trackingChart: observable,
      permittedBuilding: observable,
      deletCustomEmissionData: observable,
      customEmission: observable,
      childCompanyNavbar: observable,
      selectedCustomEmission: observable,
      selectedChildCompany: observable,
      selectedFacilityCompany: observable,
      allBuildingType: observable,
      focusArea: observable,
      accessmentList: observable,
      deleteCheckedArray: observable,
      isClickedDeleteSite: observable,
      selectedCertifications: observable,
      certificateArray: observable,
      tokenStatus: observable,
      uploadLogoImage: observable,
      photo: observable,
      frameworkTitle: observable,
      frameworkDescription: observable,
      activityLog: observable,
      y2yEnergy: observable,
      y2yS1Emissions: observable,
      y2yS2Emissions: observable,
      y2yS3Emissions: observable,
      y2yWater: observable,
      frameworkProgress: observable,
      theme: observable,
      isDarkMode: observable,
      isHover: observable,
      hoverId: observable,
      permittedBuildingLoading: observable,
      demoSitePerformanceData: observable,
      siteModuleData: observable,
      list: observable,
      showBaseLineModal: observable,
      viewStatus: observable,
      tableColumns: observable,
      groupStatus: observable,
      yearOptions: observable,
      netZeroYearOptions: observable,
      assetList: observable,
      y2yAssetEnergy: observable,
      y2yAssetS1Emissions: observable,
      y2yAssetS2Emissions: observable,
      y2yAssetS3Emissions: observable,
      customEmissionFactorList: observable,
      customEmissionFactorCount: observable,
      getAllChildCompanyCount: observable,
      getExpiryUserCount: observable,
      allChildCompanyList: observable,
      allFacilityCompanyList: observable,
      allUserOperators: observable,
      showDeleteDialog: observable,
      detailedCustomFactor: observable,
      baseLineAssetS1Consumption: observable,
      baseLineAssetS2Consumption: observable,
      baseLineAssetS3Consumption: observable,
      PCFUserIdData: observable,
      CTBCUserIdData: observable,
      language: observable,

      baseLineAssetS1Emissions: observable,
      baseLineAssetS2Emissions: observable,
      baseLineAssetS3Emissions: observable,
      feedback: observable,
      feedbackSubmitted: observable,
      feedbackList: observable,
      errorAlertMessage: observable,
      selectedCompany: observable,
      company_list: observable,
      company_list_v2: observable,
      userEmail: observable,
      field: observable,
      emissionUnit: observable,
      excelSelectDownload: observable,
      excelYearOptions: observable,
      selectedExcelYear: observable,
      selectedCategory: observable,
      selectedScope: observable,
      selectedLabel: observable,
      isPCF: observable,
      isCTBC: observable,

      setSelectedYear: action.bound,
      setSelectedPeriod: action.bound,
      setSelectedMonth: action.bound,
      setSelectedQuarter: action.bound,
      setSelectedCompany: action.bound,
      _handleShowDeleteDialog: action.bound,
      _handleCancelDeleteDialog: action.bound,
      _handleSelectedEmissionFactorListChange: action.bound,
      _handleSelectedChildCompanyListChange: action.bound,
      _handleSelectedFacilityCompanyListChange: action.bound,
      _handleCertificationCheck: action.bound,
      _handleTargetCheck: action.bound,
      addDefaultSrc: action.bound,
      _handleUploadImage: action.bound,
      _resetImage: action.bound,
      getY2yAssetEnergy: action.bound,
      getY2yAssetWater: action.bound,
      getY2yAssetScopeEmissions: action.bound,
      onChangeTheme: action.bound,
      _handleGetYearOptions: action.bound,
      _handleGetNetZeroYearOptions: action.bound,
      getAssetList: action.bound,
      _handleChangeFeedbackData: action.bound,
      submitFeedback: action.bound,
      getFeedbacks: action.bound,
      _handleVerify: action.bound,
      _handleCustomEmissionFactorDetail: action.bound,
      _handleSort: action.bound,
      calulationForScope: action.bound,
      _handleChangeField: action.bound,
      _handleSwitchChange: action.bound,
      _handleExcelSelectDownload: action.bound,
      _handleGetExcelYearOptions: action.bound,
      _handleSelectedCategory: action.bound,
      _handleSelectedYearChange: action.bound,
      _handleChangeTheme: action.bound,
      _setLanguage: action.bound,
    });
  }
  _setLanguage = (newLanguage) => {
    runInAction(() => {
      this.language = newLanguage;
    });
  };

  _handleChangeTheme = () => {
    runInAction(() => {
      localStorage.setItem("theme", "light");
      this.theme = "light";
    });
  };

  _handleSelectedCategory = (e) => {
    runInAction(() => {
      this.selectedScope = e.scope;
      this.selectedLabel = e.label;
      this.selectedCategory = e.key;
    });
  };

  _handleSelectedYearChange = (e) => {
    runInAction(() => {
      this.selectedExcelYear = e.label;
    });
  };

  _handleSwitchChange = (value) => {
    runInAction(() => {
      this.cookies.set("emissionUnit-" + this.userId, value);
      this.emissionUnit = value;
    });
  };
  _handleGetExcelYearOptions = (baselineYear) => {
    let years = [];
    const currentYear = new Date().getFullYear();
    for (let i = baselineYear; i <= currentYear; i++) {
      years.push({
        label: String(i),
        value: Number(i),
      });
    }
    this.excelYearOptions = years;
    this.list = years;
  };

  _handleExcelSelectDownload = (yes, no, all) => {
    runInAction(() => {
      this.excelSelectDownload.yes = yes;
      this.excelSelectDownload.no = no;
      this.excelSelectDownload.all = all;
    });
  };

  _handleVerify = (value, type) => {
    let newDetailedFactor = this.detailedCustomFactor;
    newDetailedFactor.isVerified = value;
    if (type === "reject") newDetailedFactor.isRejected = true;
    else if (value === true) newDetailedFactor.isRejected = false;
    this.detailedCustomFactor = newDetailedFactor;
    const bodyData = {
      scope: this.detailedCustomFactor.scopeName,
      category: this.detailedCustomFactor.category,
      companyId: this.detailedCustomFactor.company._id,
      type:
        this.detailedCustomFactor.category === "Imported Energy"
          ? "Supplier-specific"
          : "Custom Emission",
      year: Number(this.detailedCustomFactor.year),
      methods: [
        {
          sourceOfEmission: this.detailedCustomFactor.emissionName,
          co2Factor: this.detailedCustomFactor.co2FactorValue,
          n2oFactor: this.detailedCustomFactor.n2oFactorValue || 0,
          ch4Factor: this.detailedCustomFactor.ch4FactorValue || 0,
          hfcsFactor: this.detailedCustomFactor.hfcsFactorValue || 0,
          pfcsFactor: this.detailedCustomFactor.pfcsFactorValue || 0,
          sf6Factor: this.detailedCustomFactor.sf6FactorValue || 0,
          nf3Factor: this.detailedCustomFactor.nf3FactorValue || 0,
          isKgCo2: this.detailedCustomFactor.isKgCo2,
          baseUnit: this.detailedCustomFactor.baseUnit,
          isVerified:
            type === "reject" ? false : this.detailedCustomFactor.isVerified,
          isRejected: type === "reject" ? true : false,
        },
      ],
    };

    changeVerifyStatus(bodyData, (err, data) => {
      if (!err && data.success) {
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.CUSTOM_EF_UPDATE_SUCCESS,
        });
      }
    });
  };
  _handleChangeField = (value) => {
    runInAction(() => {
      this.field = value;
    });
  };

  _handleShowDeleteDialog = (value, row) => {
    this.showDeleteDialog = value;
    this.deletCustomEmissionData = row;
    this.errorAlertMessage = "";
  };
  _handleCancelDeleteDialog = (value) => {
    this.showDeleteDialog = value;
  };
  _handleSelectedEmissionFactorListChange = (value) => {
    this.selectedCustomEmission = value;
  };

  _handleSelectedChildCompanyListChange = (value) => {
    this.selectedChildCompany = value;
  };

  _handleSelectedFacilityCompanyListChange = (value) => {
    this.selectedFacilityCompany = value;
  };

  _handleCustomEmissionFactorDetail = (data) => {
    this.detailedCustomFactor = data;
  };

  _handleGetYearOptions = (baselineYear) => {
    let years = [];
    this.list = [];
    const currentYear = new Date().getFullYear();
    for (let i = baselineYear; i <= currentYear; i++) {
      years.push({
        label: String(i),
        value: Number(i),
      });
    }
    this.yearOptions = years;
    this.list = years;
    this.list.unshift({ label: "All", value: "All" });
  };
  _handleGetNetZeroYearOptions = (baselineYear) => {
    let years = [];
    const currentYear = new Date().getFullYear() + 5;
    for (let i = baselineYear; i <= currentYear; i++) {
      years.push({
        label: String(i),
        value: Number(i),
      });
    }
    this.netZeroYearOptions = years;
    this.list = years;
  };

  onChangeTheme() {
    this.theme = this.theme === "dark" ? "light" : "dark";
    this.isDarkMode = false;
    localStorage.setItem("theme", this.theme);
    var x = document.getElementsByTagName("BODY")[0];
    this.theme === "dark"
      ? (x.style.backgroundImage = "linear-gradient(-60deg,#101841,#202b60)")
      : (x.style.backgroundImage = "linear-gradient(-60deg,#F6F6F6,#F6F6F6)");
  }

  setSelectedCompany = (company) => {
    this.selectedCompany = company;
    if (company != null) {
      this.getGroupReports(company);
    }
  };

  setSelectedYear = (year) => {
    this.selectedYear = year;
    const specificId =
      this.siteModuleData?.levelStatus === "parent"
        ? this.siteModuleData._id
        : this.siteModuleData.parentCompanyId;
    this.getGroupReports(specificId);
  };

  setSelectedPeriod = (period) => {
    runInAction(() => {
      if (period == "yearly") {
        this.list?.unshift({ label: "All", value: "All" });
        this.selectedPeriod = period;
        this.selectedYear = "All";
      } else {
        this.list = this.list?.filter((v) => v.label !== "All");
        this.selectedYear = new Date().getFullYear();
        this.selectedPeriod = period;
        if (period == "monthly") {
          this.selectedMonth = 0;
        } else {
          this.selectedQuarter = 0;
        }
      }
    });
  };

  setSelectedMonth = (month) => {
    runInAction(() => {
      this.selectedMonth = month;
    });
  };
  setSelectedQuarter = (e) => {
    runInAction(() => {
      this.selectedQuarter = e.value;
      this.selectedQuarterLabel = e.label;
    });
  };

  _handleUploadImage = (e) => {
    this.uploadLogoImage = URL.createObjectURL(e.target.files[0]);
    this.photo = e.target.files[0];
  };

  _resetImage = () => {
    this.uploadLogoImage = "";
    this.photo = null;
  };

  getAssetList() {
    fetchAssetList((err, data) => {
      if (err) {
        showUnknownError(err);
      } else {
        if (!data.error) {
          runInAction(() => {
            this.assetList = data.payload;
          });
        }
      }
    });
  }

  getY2yAssetEnergy() {
    this.y2yEnergy = [];
    fetchY2yAssetEnergy((err, data) => {
      if (err) {
        showUnknownError(err);
        this.y2yEnergy = [];
      } else {
        if (!data.error) {
          if (data.payload?.length > 0) {
            data.payload.forEach((data) => {
              if (data.data.length > this.list.length) {
                const tempArr = [];
                data.data.forEach((d) =>
                  tempArr.push({ label: d.year, value: d.year })
                );
                this.list = tempArr;
              }
            });

            runInAction(() => {
              const percentageValues = data.payload.map((v, k) => {
                return {
                  ...v,
                  data: v.data.map((vv, kk) => {
                    return {
                      year: vv.year,
                      value: vv.value.toFixed(2),
                    };
                  }),
                };
              });
              this.y2yEnergy = percentageValues;
            });
          }
        }
      }
    });
  }

  getY2yAssetWater() {
    this.y2yWater = [];
    fetchY2yAssetWater((err, data) => {
      if (err) {
        showUnknownError(err);
        this.y2yWater = [];
      } else {
        if (!data.error) {
          if (data.payload?.length > 0) {
            const waterData = [];
            data.payload.forEach((data) => {
              if (data.label !== null) {
                waterData.push(data);
              }
            });

            runInAction(() => {
              this.y2yWater = waterData;
            });
          }
        }
      }
    });
  }

  calulationForScope = (co2GWPValue, ch4GWPValue, n2oGWPValue) => {
    let tempco2GWPValue = co2GWPValue ? co2GWPValue : 0;
    let tempch4GWPValue = ch4GWPValue ? ch4GWPValue : 0;
    let tempn2oGWPValue = n2oGWPValue ? n2oGWPValue : 0;
    let total = tempco2GWPValue + tempch4GWPValue + tempn2oGWPValue;
    return total === 0 ? 0 : total.toFixed(2);
  };

  getY2yAssetScopeEmissions(scope, year, companyId) {
    this[`y2yS${scope}Emissions`] = [];
    fetchY2yAssetScopeEmissions(
      scope,
      year,
      companyId,
      this.selectedPeriod === "monthly" ? this.selectedMonth + 1 : undefined,
      (err, data) => {
        if (err) {
          this[`y2yS${scope}Emissions`] = [];
          showUnknownError(err);
        } else {
          if (!data.error) {
            if (data.payload?.length > 0) {
              data.payload.forEach((data) => {
                if (data.data.length > this.list.length) {
                  const tempArr = [];
                  data.data.forEach((d) =>
                    tempArr.push({ label: d.year, value: d.year })
                  );
                  this.list = tempArr;
                }
              });
              runInAction(() => {
                //////////// Convert MtCo2e from kgCo2 for Digital Edge ///////////
                const convertedValues = data.payload.map((v, k) => {
                  return {
                    ...v,
                    data: v.data.map((vv, kk) => {
                      return {
                        ...vv,
                        value: this.calulationForScope(
                          vv.co2GWPValue,
                          vv.ch4GWPValue,
                          vv.n2oGWPValue
                        ),
                      };
                    }),
                  };
                });
                this[`y2yS${scope}Emissions`] = convertedValues;
              });
            }
          }
        }
      }
    );
  }

  _handleCertificationCheck(value) {
    this.certification = {
      imageURL: value.imageURL,
      name: value.name,
      id: value._id,
      isTracking: false,
    };
    const isSelected = this.selectedCertifications.findIndex(
      (v) => v.id === value._id && v.name === value.name
    );

    if (isSelected === -1) {
      runInAction(() => {
        this.selectedCertifications = [
          ...this.selectedCertifications,
          this.certification,
        ];
      });
    } else {
      this.selectedCertifications.splice(isSelected, 1);
    }
  }

  _handleTargetCheck(value) {
    value = { ...value, isTracking: !value.isTracking };
    const isSelected = this.certificateArray.findIndex(
      (v) => v.id === value.id
    );

    if (isSelected === -1) {
    } else {
      this.certificateArray[isSelected] = value;
    }
  }

  addDefaultSrc = (ev) => {
    ev.target.src = noImageUrl;
  };

  _handleChangeFeedbackData = (value, type) => {
    if (type === "feedbackData") {
      runInAction(() => {
        this.feedback.feedbackData.message = value;
      });
    } else {
      runInAction(() => {
        this.feedbackSubmitted = false;
        this.feedback[type] = value;
      });
    }
  };

  submitFeedback = () => {
    if (!this.feedback.feedbackType) {
      toast.error(
        `${i18n.t("Please select type of feedback", { ns: "common" })}`
      );
    } else if (
      this.feedback.feedbackType !== "Suggesstion" &&
      !this.feedback.feedbackData.message
    ) {
      toast.error(`${i18n.t("Please fill message", { ns: "common" })}`);
    } else if (
      this.feedback.feedbackType === "Suggesstion" &&
      !this.feedback.suggesstion
    ) {
      toast.error(`${i18n.t("Please fill suggesstion", { ns: "common" })}`);
    } else {
      addFeedback(this.feedback, (err, data) => {
        if (data.success) {
          showSuccessToast({
            apiData: data,
            scenarioCode: MESSAGE_CODES.FEEDBACK_SEND_SUCCESS,
          });
          runInAction(() => {
            this.feedbackSubmitted = true;
            this.feedback = {
              feedbackType: null,
              feedbackData: {
                message: null,
              },
              suggesstion: null,
            };
          });
        }
      });
    }
  };

  getFeedbacks = () => {
    getFeedbackList((err, data) => {
      if (data.success) {
        runInAction(() => {
          this.feedbackList = data.payload;
        });
      } else {
        showUnknownError(data.payload);
      }
    });
  };

  getCustomEmissionFactors = () => {
    getCustomEmissionFactorList((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.customEmissionFactorList = data.payload;
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getCustomEmissionFactoryCount = () => {
    getCustomEmissionFactorCount((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.customEmissionFactorCount = data.payload;
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getAllChildCompaniesCount = () => {
    getAllChildCompanyCount((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.getAllChildCompanyCount = data.payload;
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getExpiryUsersCount = () => {
    getExpiryUserCount((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.getExpiryUserCount = data.payload;
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getAllChildCompanies = () => {
    getAllChildCompanyList((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.allChildCompanyList = data.payload;
          if (this.role === MyConstants.SYSTEM_ADMIN) {
            this.getAllChildCompaniesCount();
          }
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getAllFacilityCompanies = () => {
    getAllFacilityCompanyList((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.allFacilityCompanyList = data.payload;
          if (this.role === MyConstants.SYSTEM_ADMIN) {
            this.getAllChildCompaniesCount();
          }
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  getAllUserOperators = () => {
    getAllUserOperator((err, data) => {
      if (err) {
        return showUnknownError(err);
      }
      if (data.success) {
        runInAction(() => {
          this.allUserOperators = data.payload;
        });
      } else {
        showUnknownError(data.error);
      }
    });
  };

  DeleteCustomEmissionFactors = () => {
    const customCalID = this.deletCustomEmissionData._id;
    const id = this.deletCustomEmissionData.id
      ? this.deletCustomEmissionData.id
      : 1;
    const companyID = this.deletCustomEmissionData.company._id;

    DeleteCustomEmissionFactorList(customCalID, id, companyID, (err, data) => {
      if (data.success) {
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.CUSTOM_EF_DELETE_SUCCESS,
        });
        this._handleCancelDeleteDialog(false);
        getCustomEmissionFactorList((err, data) => {
          if (err) {
            return showUnknownError(err);
          }
          if (data.success) {
            runInAction(() => {
              this.customEmissionFactorList = data.payload;
            });
          } else {
            this._handleCancelDeleteDialog(false);
            showUnknownError(data.error);
          }
        });
      } else {
        this.errorAlertMessage = data.payload;
        showUnknownError(data.error);
      }
    });
  };

  _handleSort = (data) => {
    return data.sort((a, b) => {
      if (a.label === "Others") {
        return 1;
      } else if (b.label === "Others") {
        return -1;
      } else {
        return a.label.localeCompare(b.label);
      }
    });
  };
}

export default new Common();
